import {store} from '../../redux/store';
import {showUploadModal, hideUploadModal} from './reducer';
import {ShowUploadModalProps} from '../../interfaces/connected-components/uploadModal';

/**
 * Show upload modal
 */
export const openUploadModal = ({
  onSelectionChange,
  options,
}: ShowUploadModalProps) => {
  store.dispatch(
    showUploadModal({
      onSelectionChange,
      options,
    }),
  );
};

/**
 * Hide upload modal
 */
export const hideGlobalUploadModal = () => {
  store.dispatch(hideUploadModal());
};
